import React from 'react';
import { SVGProps } from './type';

const Icon = ({ fill }: SVGProps) => (
  <g>
    <path
      d="M22.6893 0.333313C24.1637 0.333313 25.572 0.9435 26.5803 2.01897L38.5576 14.7947C39.4843 15.7832 40 17.0874 40 18.4424V48.3333C40 51.2789 37.7613 53.6666 35 53.6666H5C2.23859 53.6666 0 51.2789 0 48.3333V5.66665C0 2.72113 2.23859 0.333313 5 0.333313H22.6893ZM19.3333 5.66665H9C6.05448 5.66665 5 6.72113 5 9.66665V44.3333C5 47.2789 6.05448 48.3333 9 48.3333H31C33.9456 48.3333 35 47.2789 35 44.3333V22.3333H21.3333C20.2288 22.3333 19.3333 21.4379 19.3333 20.3333V5.66665ZM23.3333 6.40939V18.3333H34.4699C34.2368 17.8505 33.9304 17.4016 33.5576 17.0038L24.5093 7.3523C24.1605 6.98035 23.764 6.66406 23.3333 6.40939Z"
      transform="scale(0.4 0.4) translate(10 3)"
      fill={fill}
    />
  </g>
);

export default Icon;
